var ActionFactories, MainPage, MarkerMap, Markers, NewMarker, PlaceEngine, m;

m = require('mithril');

ActionFactories = require('../../state/ActionFactories');

NewMarker = require('../components/NewMarker');

Markers = require('../components/Markers');

MarkerMap = require('../components/MarkerMap');

PlaceEngine = require('../../lib/PlaceEngine');

MainPage = {
  view: function(ctrl, args) {
    return m('.page', [
      m(MarkerMap, {
        markers: args.markers,
        average: args.average,
        centre: args.centre,
        places: args.places,
        apiLoaded: args.apiLoaded,
        onCentreChanged: args.onCentreChanged,
        onMarkerMoved: args.onMarkerMoved
      }), m('h2', 'People'), m(Markers, {
        markers: args.markers,
        onRemove: args.onRemove
      }), m('p', 'Add a person then drag their marker into position. The weighted average of all people added will be added automatically (marked with an "X") along with the nearest places to eat or drink.'), m(NewMarker, {
        centre: args.centre,
        onAdd: args.onAdd,
        apiLoaded: args.apiLoaded
      })
    ]);
  }
};

module.exports = function(store) {
  var engine;
  engine = new PlaceEngine(store);
  return m(MainPage, {
    markers: function() {
      return store.getState().markers;
    },
    centre: function() {
      return store.getState().centre;
    },
    average: function() {
      return store.getState().average;
    },
    places: function() {
      return store.getState().places;
    },
    apiLoaded: function() {
      return store.getState().apiLoaded;
    },
    onAdd: function(marker) {
      store.dispatch(ActionFactories.markerAdded(marker));
      return engine.search(store.getState().centre);
    },
    onRemove: function(marker) {
      store.dispatch(ActionFactories.markerRemoved(marker));
      return engine.search(store.getState().centre);
    },
    onCentreChanged: function(centre) {
      store.dispatch(ActionFactories.centreChanged(centre));
      return engine.search(store.getState().centre);
    },
    onMarkerMoved: function(marker, position) {
      var k, newMarker, v;
      newMarker = {};
      for (k in marker) {
        v = marker[k];
        newMarker[k] = v;
      }
      newMarker.position = position;
      store.dispatch(ActionFactories.markerMoved(newMarker));
      return engine.search(store.getState().centre);
    }
  });
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3dvcmsvc3JjL3VpL3BhZ2VzL01haW5QYWdlLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi93b3JrL3NyYy91aS9wYWdlcy9NYWluUGFnZS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxDQUFBLEdBQUksT0FBQSxDQUFRLFNBQVI7O0FBRUosZUFBQSxHQUFrQixPQUFBLENBQVEsNkJBQVI7O0FBQ2xCLFNBQUEsR0FBYyxPQUFBLENBQVEseUJBQVI7O0FBQ2QsT0FBQSxHQUFZLE9BQUEsQ0FBUSx1QkFBUjs7QUFDWixTQUFBLEdBQWMsT0FBQSxDQUFRLHlCQUFSOztBQUNkLFdBQUEsR0FBZSxPQUFBLENBQVEsdUJBQVI7O0FBRWYsUUFBQSxHQUFXO0VBQ1YsSUFBQSxFQUFNLFNBQUMsSUFBRCxFQUFPLElBQVA7V0FDTCxDQUFBLENBQUUsT0FBRixFQUFXO01BQ1YsQ0FBQSxDQUFFLFNBQUYsRUFBYTtRQUNaLE9BQUEsRUFBUyxJQUFJLENBQUMsT0FERjtRQUVaLE9BQUEsRUFBUyxJQUFJLENBQUMsT0FGRjtRQUdaLE1BQUEsRUFBUSxJQUFJLENBQUMsTUFIRDtRQUlaLE1BQUEsRUFBUSxJQUFJLENBQUMsTUFKRDtRQUtaLFNBQUEsRUFBVyxJQUFJLENBQUMsU0FMSjtRQU1aLGVBQUEsRUFBaUIsSUFBSSxDQUFDLGVBTlY7UUFPWixhQUFBLEVBQWUsSUFBSSxDQUFDLGFBUFI7T0FBYixDQURVLEVBVVYsQ0FBQSxDQUFFLElBQUYsRUFBUSxRQUFSLENBVlUsRUFXVixDQUFBLENBQUUsT0FBRixFQUFXO1FBQ1YsT0FBQSxFQUFTLElBQUksQ0FBQyxPQURKO1FBRVYsUUFBQSxFQUFVLElBQUksQ0FBQyxRQUZMO09BQVgsQ0FYVSxFQWVWLENBQUEsQ0FBRSxHQUFGLEVBQU8sNkxBQVAsQ0FmVSxFQWdCVixDQUFBLENBQUUsU0FBRixFQUFhO1FBQ1osTUFBQSxFQUFRLElBQUksQ0FBQyxNQUREO1FBRVosS0FBQSxFQUFPLElBQUksQ0FBQyxLQUZBO1FBR1osU0FBQSxFQUFXLElBQUksQ0FBQyxTQUhKO09BQWIsQ0FoQlU7S0FBWDtFQURLLENBREk7OztBQTBCWCxNQUFNLENBQUMsT0FBUCxHQUFpQixTQUFDLEtBQUQ7QUFDaEIsTUFBQTtFQUFBLE1BQUEsR0FBUyxJQUFJLFdBQUosQ0FBZ0IsS0FBaEI7U0FDVCxDQUFBLENBQUUsUUFBRixFQUFZO0lBQ1gsT0FBQSxFQUFTLFNBQUE7YUFBTSxLQUFLLENBQUMsUUFBTixDQUFBLENBQWdCLENBQUM7SUFBdkIsQ0FERTtJQUVYLE1BQUEsRUFBUSxTQUFBO2FBQU0sS0FBSyxDQUFDLFFBQU4sQ0FBQSxDQUFnQixDQUFDO0lBQXZCLENBRkc7SUFHWCxPQUFBLEVBQVMsU0FBQTthQUFNLEtBQUssQ0FBQyxRQUFOLENBQUEsQ0FBZ0IsQ0FBQztJQUF2QixDQUhFO0lBSVgsTUFBQSxFQUFRLFNBQUE7YUFBTSxLQUFLLENBQUMsUUFBTixDQUFBLENBQWdCLENBQUM7SUFBdkIsQ0FKRztJQUtYLFNBQUEsRUFBVyxTQUFBO2FBQU0sS0FBSyxDQUFDLFFBQU4sQ0FBQSxDQUFnQixDQUFDO0lBQXZCLENBTEE7SUFPWCxLQUFBLEVBQU8sU0FBQyxNQUFEO01BQ04sS0FBSyxDQUFDLFFBQU4sQ0FBZSxlQUFlLENBQUMsV0FBaEIsQ0FBNEIsTUFBNUIsQ0FBZjthQUNBLE1BQU0sQ0FBQyxNQUFQLENBQWMsS0FBSyxDQUFDLFFBQU4sQ0FBQSxDQUFnQixDQUFDLE1BQS9CO0lBRk0sQ0FQSTtJQVVYLFFBQUEsRUFBVSxTQUFDLE1BQUQ7TUFDVCxLQUFLLENBQUMsUUFBTixDQUFlLGVBQWUsQ0FBQyxhQUFoQixDQUE4QixNQUE5QixDQUFmO2FBQ0EsTUFBTSxDQUFDLE1BQVAsQ0FBYyxLQUFLLENBQUMsUUFBTixDQUFBLENBQWdCLENBQUMsTUFBL0I7SUFGUyxDQVZDO0lBYVgsZUFBQSxFQUFpQixTQUFDLE1BQUQ7TUFDaEIsS0FBSyxDQUFDLFFBQU4sQ0FBZSxlQUFlLENBQUMsYUFBaEIsQ0FBOEIsTUFBOUIsQ0FBZjthQUNBLE1BQU0sQ0FBQyxNQUFQLENBQWMsS0FBSyxDQUFDLFFBQU4sQ0FBQSxDQUFnQixDQUFDLE1BQS9CO0lBRmdCLENBYk47SUFnQlgsYUFBQSxFQUFlLFNBQUMsTUFBRCxFQUFTLFFBQVQ7QUFDZCxVQUFBO01BQUEsU0FBQSxHQUFZO0FBQ1osV0FBQSxXQUFBOztRQUFBLFNBQVUsQ0FBQSxDQUFBLENBQVYsR0FBZTtBQUFmO01BQ0EsU0FBUyxDQUFDLFFBQVYsR0FBcUI7TUFDckIsS0FBSyxDQUFDLFFBQU4sQ0FBZSxlQUFlLENBQUMsV0FBaEIsQ0FBNEIsU0FBNUIsQ0FBZjthQUNBLE1BQU0sQ0FBQyxNQUFQLENBQWMsS0FBSyxDQUFDLFFBQU4sQ0FBQSxDQUFnQixDQUFDLE1BQS9CO0lBTGMsQ0FoQko7R0FBWjtBQUZnQiJ9
